import React, { useState } from "react";
import CarErecursos from "../element/CarErecursos";

import useErecursos from '../hooks/useErecursos';

const TIPOS = [
    { key: 'DB', label: 'Bases de datos', icon: 'fa-database' },
    { key: 'JOURNAL', label: 'Journals', icon: 'fa-newspaper-o' },
    { key: 'EBOOK', label: 'E-books', icon: 'fa-book' },
];

const ErecursosItems = ({ carnet, recursos }) => {

    const [recurso] = useErecursos(recursos);
    const [tipo, setTipo] = useState('DB');

    const lista = recurso.filter(erecurso => erecurso.tipo === tipo);

    const cambiarTipo = (nuevo) => {
        setTipo(nuevo);
        const carbody = document.getElementById('content');
        if (carbody) {
            carbody.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <div>
            <div className="esen-tabs" role="tablist" aria-label="Tipo de recurso">
                {TIPOS.map((t) => (
                    <button
                        key={t.key}
                        type="button"
                        role="tab"
                        aria-selected={tipo === t.key}
                        className={tipo === t.key ? 'esen-tab esen-tab--active' : 'esen-tab'}
                        onClick={() => cambiarTipo(t.key)}
                    >
                        <i className={`fa ${t.icon} mr-1`} aria-hidden="true"></i>
                        {t.label}
                    </button>
                ))}
            </div>

            <div className="esen-resource-grid">
                {lista.map((element) => (
                    <CarErecursos
                        key={element.prefijoid}
                        recurso={element}
                        carnet={carnet}
                    />
                ))}
            </div>
        </div>
    );
}

export default ErecursosItems;
